module.exports = __webpack_public_path__ + "static/img/loading.1913c63.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/flexible-ui/images/loading.gif
// module id = J3fM
// module chunks = 1